export default "__VITE_ASSET__bd8f5411__"